import { ComponentPlaceholderIcon } from '@radix-ui/react-icons'
import { clsx } from 'clsx'
import { Button } from '~/sotano-kit/primitives/button'

type SocialProviderLoginButtonProps = {
  text: string
  onClick: () => void
  icon: React.ReactNode
  loading: boolean
}

export const SocialProviderLoginButton = ({
  text,
  onClick,
  loading,
  icon,
}: SocialProviderLoginButtonProps) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    onClick()
  }
  return (
    <Button
      unstyled
      focusStyled
      aria-label={text}
      onClick={handleClick}
      className="relative mb-2 flex h-14 w-full cursor-pointer items-center justify-center rounded-lg border border-dark-border-solid bg-dark-shade light:bg-dark-base text-sm transition-all duration-150 last:mb-0 hover:bg-dark-shade-hover"
    >
      {icon}
      <span className={clsx('', loading && 'animate-fade-out')}>{text}</span>
      {loading && (
        <span
          className="invisible absolute left-1/2 inline-flex -translate-x-1/2 animate-fade-in items-center justify-center space-x-1.5"
          style={{ animationDelay: '0.1s' }}
        >
          {loading && <span className="text-dark-faint">Redirecting...</span>}
          <ComponentPlaceholderIcon className="animate-loading" />
        </span>
      )}
    </Button>
  )
}
